export const LogoMark = ({ className = "h-9 w-auto" }) => (
    <img src="/logo-mark.png" alt="Santa Lucia Quattro" className={className} />
);

export const LogoFull = ({ dark = false, className = "h-12 w-auto" }) => (
    <span data-testid="nav-logo" className="inline-flex items-center">
        <img
            src="/logo-horizontal.png"
            alt="Santa Lucia Quattro — Impresa Edile"
            className={`${className} ${dark ? "rounded-md bg-white px-3 py-1.5" : ""}`}
        />
    </span>
);
